import { useQuery } from '@tanstack/react-query';

import { useAvApi } from '@app-velocity/av-api-v2';

export const useGetGuestAiReviewDetailsQuery = (
  shareToken?: string,
  reviewId?: string,
  refetch?: boolean
) => {
  const { guestPrototypesShare } = useAvApi();

  const data = useQuery({
    enabled: !!shareToken && !!reviewId,
    queryKey: ['ai-review', shareToken, reviewId],
    queryFn: async () => {
      if (!shareToken || !reviewId) return;
      const data =
        await guestPrototypesShare.getV2GuestPrototypesShareAiReviewsByShareTokenAndReviewId(
          {
            shareToken,
            reviewId,
          }
        );

      return data.data;
    },
    refetchInterval: refetch ? 1000 : undefined,
    refetchOnReconnect: true,
    refetchOnMount: true,
    refetchOnWindowFocus: true,
  });

  return data;
};
